import {toDateFromServer} from '../../../../utils/formatter'
import {isSameDate} from '../../../../utils/helper'
import store from '../../../../store'

export const makeEmptyServizioFilter = () => {
  return {
    prezzo: null,
    nome: null,
    data: null
  }
}

export const makeService = (service) => {
  return makeServices([service])[0]
}

export const makeServices = (list, trasferimentiCodeList = [], isServiceList = true) => {
  // preleva tutte le anagrafiche dei servizi
  const anagraficaList = store.getters.getServiceList

  let result = []
  list.forEach((service) => {
    // make day property
    // venditaTotaleEuro a livello di prezzo giornaliero (somma di vendita totale euro del prezzo giornaliero dei gruppi)
    // venditaTotaleEuro a livello di gruppo
    const pricesByDay = [...service.pricesByDay].map(item => {
      const venditaTotaleEuro = item.prices.map(item => item.prices[0].price.venditaTotaleEuro).reduce((totale, current) => {
        return totale + current
      })
      item.prices.forEach(item => {
        item.venditaTotaleEuro = item.prices[0].price.venditaTotaleEuro
      })
      return {
        ...item,
        day: toDateFromServer(item.period.start.date),
        venditaTotaleEuro
      }
    })

    // venditaTotaleEuro minimo a livello di servizio, utilizzato per filtrare la pratica per prezzo
    const venditaTotaleEuro = pricesByDay.map(item => item.venditaTotaleEuro).reduce((totale, current) => {
      return Math.min(totale, current)
    })

    // make groups
    const groups = pricesByDay[0].prices.map(item => {
      return {
        id: item.group,
        selected: true,
        dateSelected: null
      }
    })

    // make dates
    const dates = pricesByDay.map(item => item.day)

    // filtra i trasferimenti o i servizi
    const { productID } = service.response.detail
    const isTrasferimento = trasferimentiCodeList.some(item2 => item2 === productID)
    if ((isServiceList && isTrasferimento) || (!isServiceList && !isTrasferimento)) {
      return
    }

    // aggancia le configurazioni
    const serviziList = store.getters.getServizi.list
    const config = serviziList.find(item => {
      return item.codice === productID
    })

    // se non esiste una configurazione per lo specifico servizio lo dichiamo: notConfigured true
    const nonConfigurato = config == null
    if (config == null) {
      console.warn('servizio senza configurazione, productID = ', productID)
    }

    // aggancia l'anagrafica
    const anagrafica = anagraficaList.find(anag => {
      return anag.detailResponse && anag.detailResponse.detail && anag.detailResponse.detail.productID === productID
    })

    // i servizi senza anagrafica sono automaticamente esclusi
    if (anagrafica == null) {
      console.warn('servizio senza anagrafica, productID = ', productID)
      return
    }
    const {detail, notes} = service.response
    result.push({ pricesByDay, config, anagrafica, detail, notes, dates, groups, venditaTotaleEuro, nonConfigurato })
  })
  return result
}

export const addReplaceServizioAction = (state, servizio) => {
  if (!servizio.isTrasferimento) {
    const index = state.services.selected.findIndex(item => item.detail.productID === servizio.detail.productID)
    // i servizi possono essere istanziati una volta sola, pertanto se c'è l'unica istanza va modificata
    if (index < 0) {
      state.services.selected.push({...servizio, groups: servizio.groups})
    } else {
      state.services.selected.splice(index, 1, servizio)
    }
  } else {
    if (servizio.isAndata) {
      state.trasferimenti.andata = {...servizio, groups: [...servizio.groups]}
    } else {
      state.trasferimenti.ritorno = {...servizio, groups: [...servizio.groups]}
    }
  }
}

export const removeSelectedServizio = (state, payload) => {
  const {day, servizio} = payload
  const ctx = takeContext(state, servizio)
  if (!servizio.isTrasferimento) {
    // estraggo il servizio
    const indexFound = ctx.selected.findIndex(item => item.detail.productID === servizio.detail.productID)
    if (indexFound >= 0) {
      const serviceStored = ctx.selected[indexFound]
      // per ogni se la dateSelected corrisponde a day la cancello
      serviceStored.groups.forEach((group) => {
        if (isSameDate(group.dateSelected, day)) {
          group.dateSelected = null
        }
      })
      // se il servizio ha tutte le dateSelected a null lo rimuovo
      const removable = serviceStored.groups.every(group => group.dateSelected === null)
      if (removable) {
        ctx.selected.splice(indexFound, 1)
      }
    }
  } else {
    if (servizio.isAndata) {
      ctx.andata = null
    } else {
      ctx.ritorno = null
    }
  }
}

export const removeSelectedServizioAll = (state, servizio) => {
  const ctx = takeContext(state, servizio)
  if (!servizio.isTrasferimento) {
    ctx.selected = ctx.selected.filter(item => {
      return item.detail.productID !== servizio.detail.productID
    })
  } else {
    ctx.andata = null
    ctx.ritorno = null
  }
}

const takeContext = (state, servizio) => {
  return servizio.isTrasferimento ? state.trasferimenti : state.services
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/services.js